import { NgClass } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { CustomDesignItemType } from '@iupics-components/models/custom-design';
import AutocompleteUiComponent from '@iupics-components/standard/fields/autocomplete-ui/autocomplete-ui.component';
import ButtonUiComponent from '@iupics-components/standard/fields/button-ui/button-ui.component';
import ModalUiComponent from '@iupics-components/standard/layouts/modal-ui/modal-ui.component';
import { DynamicComponent } from '@iupics-manager/models/dynamic-component';
import { IupicsTypeEvent } from '@iupics-manager/models/iupics-event';
import { TranslateModule } from '@ngx-translate/core';
import { ProgressBarModule } from 'primeng/progressbar';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SidebarModule } from 'primeng/sidebar';
import SpecificWindowUiComponent from '../specific-window-ui/specific-window-ui.component';

@Component({
  selector: 'iu-reject-reason-einvoice',
  templateUrl: './reject-reason-einvoice.component.html',
  styleUrls: ['./reject-reason-einvoice.component.scss'],
  standalone: true,
  imports: [
    ProgressBarModule,
    ScrollPanelModule,
    AutocompleteUiComponent,
    SidebarModule,
    ModalUiComponent,
    NgClass,
    TranslateModule,
    ButtonUiComponent,
  ],
})
export class RejectReasonEinvoinceComponent
  extends SpecificWindowUiComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('top', { read: ViewContainerRef, static: true })
  vcrTop: ViewContainerRef;

  /* Constructor */
  constructor() {
    super();
  }
  ngOnInit(): void {
    this.uiCreator.getSpecificWindow(this.formId).subscribe((specificWindow) => {
      specificWindow.items.forEach((item) => {
        if (item.data.columnName === 'Status') {
          const fieldSize = 'p-col-12  p-md-4 p-md-offset-2';
          this.customDesignArray.push({
            vcr: 'vcrTop',
            type: CustomDesignItemType.FIELD,
            columnName: 'Status',
            cssClass: fieldSize,
          });
        } else if (item.data.columnName === 'E_RejectReason_ID') {
          const fieldSize = 'p-col-12  p-md-4 ';
          this.customDesignArray.push({
            vcr: 'vcrTop',
            type: CustomDesignItemType.FIELD,
            columnName: 'E_RejectReason_ID',
            cssClass: fieldSize,
          });
        } else if (item.data.columnName === 'Message') {
          const fieldSize = 'p-col-12  p-md-8 p-md-offset-2';
          this.customDesignArray.push({
            vcr: 'vcrTop',
            type: CustomDesignItemType.FIELD,
            columnName: 'Message',
            cssClass: fieldSize,
          });
        } else if (item.data.columnName === 'Processing') {
          const fieldSize = 'p-col-12 p-md-3 p-lg-2';
          this.customDesignArray.push({
            vcr: 'vcrButtons',
            type: CustomDesignItemType.FIELD,
            columnName: 'Processing',
            cssClass: fieldSize,
            btnType: 'primary',
          });
        }
      });
      const item: DynamicComponent = {
        container: this,
        DOMParentComponent: this,
        component: 'SpecificWindowUiComponent',
        cssClass: 'p-col-12',
        isCssOnComponent: false,
        tabId: Number(this.formId),
        gridPaginator: false,
      };
      this.windowFactory.newEventHandler({
        type: IupicsTypeEvent.showSpecificWindow,
        item: item,
      });
    });
    this.componentRef.location.nativeElement.parentElement.style.overflow = 'unset';
  }

  processProcessing(item) {
    this.sourceComponent.runWFRejectReason(
      this.dataStore.data['Status'].id,
      this.dataStore.data['E_RejectReason_ID'].id,
      this.dataStore.data['Message']
    );
    this.closeModalEmitter.emit();
  }

  close() {
    this.closeModalEmitter.emit();
  }
}
